import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Icon } from "../../Icon/Icon";
import { Button } from "../../SharedComponents/Button/Button";
import { SearchBox } from "../../SharedComponents/SearchBox/SearchBox";
import { AdminRightActionsContainer } from "../AdminRightActionsContainer/AdminRightActionsContainer";
import "./AdminCountries.css";
import { AdminCountriesList } from "./AdminCountriesList/AdminCountriesList";

export const AdminCountries = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [searchTerm, setSearchTerm] = useState("");
  return (
    <div className="AdminCountries">
      <div className="AdminCountries__content">
        <AdminCountriesList searchTerm={searchTerm} />
      </div>
      <div className="AdminDistributors__right">
        <div className="AdminDistributors__search">
          <SearchBox searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        </div>
        <div className="AdminDistributors__actions">
          <AdminRightActionsContainer>
            <div className="AdminDistributors__add-new">
              <Button
                buttonStyle="Button__primary"
                click={() => history.push("/admin/administration/country")}
              >
                <Icon
                  className="AdminRightActionsContainer__add-new--icon"
                  name="iconAdd"
                  width={12}
                  height={12}
                />
                <div className="AdminRightActionsContainer__add-new--text">
                  {t("generic.addNew")}
                </div>
              </Button>
            </div>
          </AdminRightActionsContainer>
        </div>
      </div>
    </div>
  );
};
